import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './reportlist.module.css';
import { Link } from "react-router-dom";
import dayjs from 'dayjs';

const ReportList = ({ rentrollList }) => {

    return (<div className={`${styles.IncomeListUnderSec}`}>

        {rentrollList?.map((item, index) => {
            return <div key={index} className={`${styles.ListCardDivSec}`}>
                <div className={`${styles.CardDivList}`}>
                    <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>
                        {/* <img src="/static/img/avatars/avatar-4.jpg" alt="" /> */}
                        <div>
                            <p className={`${styles.Name} ${styles.Hover}`}>
                                <Link to={'/people/tenants/details/' + item?.id}><span>{item?.tenant_data?.name}</span></Link>
                            </p>
                            <p className={`${styles.Name} ${styles.Hover}`}>
                                <Link to={'/properties/details/' + item?.property_id}><span>{item?.property_data?.name}</span> - {item?.apt_name}</Link>
                            </p>
                        </div>
                    </div>
                    <div className={`${styles.SecondSec}`}>
                        <p className={`${styles.Name}`}>
                            <span>Email: <span>{item?.tenant_data?.email}</span></span>
                            <span className={`${styles.Second}`}>Rent Due Day: <span>1st</span></span>
                        </p>
                        <p className={`${styles.Name}`}>
                            <span>Rent: <span>{item?.rent?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</span></span>
                            <span className={`${styles.Second}`}>Outstanding: <span>{item?.available_balance2?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</span></span>
                        </p>
                    </div>
                    <div className={`${styles.ThirdSec}`}>
                        <p className={`${styles.Name} ${styles.Hover}`}>
                            <Link to={'/leases/details/' + item?.id}><span>{dayjs(item?.lease_start_date).format('MM/DD/YYYY') + ' - ' + dayjs(item?.lease_end_date).format('MM/DD/YYYY')}</span></Link>
                        </p>
                        <p className={`${styles.Name}`}>
                            <span>DOB: <span>{item?.tenant_data?.birth_date ? dayjs(item?.tenant_data?.birth_date).format('MM-DD-YYYY') : '-'}</span></span>
                        </p>
                    </div>
                </div>
            </div>
        })}

        {rentrollList?.length > 0 && <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 180 }}>Tenant</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 200 }}>Email</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 200 }}>Property</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>Unit</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 220 }}>Lease Term</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Rent</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Rent Due Day</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Outstanding</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>DOB</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rentrollList?.map((item, index) => {
                        return <TableRow key={index}>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}><Link to={'/people/tenants/details/' + item?.id}><span>{item?.tenant_data?.name}</span></Link></TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.tenant_data?.email}</TableCell>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}><Link to={'/properties/details/' + item?.property_id}><span>{item?.property_data?.name}</span></Link></TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.apt_name}</TableCell>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}><Link to={'/leases/details/' + item?.id}><span>{dayjs(item?.lease_start_date).format('MM/DD/YYYY') + ' - ' + dayjs(item?.lease_end_date).format('MM/DD/YYYY')}</span></Link></TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.rent?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>1st</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.available_balance2?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.tenant_data?.birth_date ? dayjs(item?.tenant_data?.birth_date).format('MM-DD-YYYY') : '-'}</TableCell>
                        </TableRow>
                    })}

                </TableBody>
            </Table>
        </TableContainer>}

        {rentrollList?.length === 0 && <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/no-report.png" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Pinata list is currently empty.</p>
            <p className={`${styles.NoDataTextSub}`}>All your reports will appear here once available.</p>
        </div>}

    </div>);
}

export default ReportList;